import React, { Component } from 'react';

/* 헤더 */
export class Header extends Component {
    render(){
        return (
            <div className="header">
                { this.props.children }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/common/UserCommon.js